"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Location = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Location = ({ style: styleOverrides = {}, size, className = "", }) => {
    const cssStyle = size !== null && size !== void 0 ? size : "100%";
    const coreStyle = {
        display: "inlineBlock",
        width: cssStyle,
        height: cssStyle,
    };
    const style = Object.assign(Object.assign({}, coreStyle), styleOverrides);
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ id: "location", viewBox: "0 0 32 32", className: `${className}`, style: style }, { children: (0, jsx_runtime_1.jsxs)("g", Object.assign({ id: "location", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg" }, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M11 4s12 2 9 17C32 2 14 0 11 4Z", fillRule: "evenodd", opacity: ".3" }), (0, jsx_runtime_1.jsx)("path", { d: "M7 10c0 4.97 8 21 9 21s9-16.03 9-21a9 9 0 1 0-18 0Zm9.086 17.436c.886-1.574 1.958-3.698 2.971-5.907C21.415 16.395 23 11.836 23 10a7 7 0 1 0-14 0c0 1.836 1.585 6.395 3.943 11.53 1.014 2.208 2.085 4.332 2.971 5.906l.086.151.086-.151Zm-1.257 1.991-.008.009a.5.5 0 0 0 .016-.018l-.008.01Z", fillRule: "evenodd" })] })) })));
};
exports.Location = Location;
